import { RefundStatus } from '@/types/refunds'

export type ParticipantRefundState = 'completed' | 'processing' | 'not_completed'

const ORGANIZER_LABEL_KEYS: Record<RefundStatus, string> = {
  [RefundStatus.Pending]: 'refunds.status.pending',
  [RefundStatus.RequiresAction]: 'refunds.status.requires_action',
  [RefundStatus.Succeeded]: 'refunds.status.succeeded',
  [RefundStatus.Failed]: 'refunds.status.failed',
  [RefundStatus.Canceled]: 'refunds.status.canceled',
}

/**
 * i18n key of the precise, organizer-facing label of a refund status.
 * `null` (a status Stripe reported that Startline does not know) maps to "Unknown".
 */
export function refundStatusLabelKey(status: RefundStatus | null): string {
  return status === null ? 'refunds.status.unknown' : ORGANIZER_LABEL_KEYS[status]
}

/**
 * Participant-facing simplification of a refund status. Only `succeeded` is
 * completed; an unknown (`null`) status is never shown as completed.
 */
export function participantRefundState(status: RefundStatus | null): ParticipantRefundState {
  switch (status) {
    case RefundStatus.Succeeded:
      return 'completed'
    case RefundStatus.Failed:
    case RefundStatus.Canceled:
      return 'not_completed'
    default:
      return 'processing'
  }
}
